import styled from 'styled-components';

export const ContainerSpin = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
